import { useState } from 'react';
import { createCompany } from '../../services/company/createCompanyService.js';
import { isNameValid, isShortnameValid, isDescriptionValid } from '../../utils/validations/companyValidations.js';

const initialForm = {
    name: '',
    shortname: '',
    description: ''
};

export const useCreateCompany = () => {
    const [form, setForm] = useState(initialForm);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [validationErrors, setValidationErrors] = useState([]);
    const clearError = () => setError('');
    const clearSuccess = () => setSuccess('');
    const clearValidationErrors = () => setValidationErrors([]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const resetForm = () => {
        setForm(initialForm);
        setError('');
        setSuccess('');
        setValidationErrors([]);
    };

    const submit = async () => {
        // LIMPIEZA GLOBAL
        setError('');
        setSuccess('');
        setValidationErrors([]);

        const { name, shortname, description } = form;

        if (!isNameValid(name)){
            setError('El nombre de la empresa solo pueden contener letras.');
            return;
        }
        if (!isShortnameValid(shortname)){
            setError('El nombre corto solo pueden contener letras y números.');
            return;
        }
        if (!isDescriptionValid(description)){
            setError('El campo comentarios no puede contener caracteres especiales.');
            return;
        }
        // Si todo esta validado, procedimiento guardar
        try {
            await createCompany(form);
            setSuccess('La empresa ha sido creada exitosamente.');
        } catch (err) {
            // Validación del archivo: middleware/validator.js del backend
            if (err.response?.status === 400 && Array.isArray(err.response.data?.errors)) {
                setValidationErrors(err.response.data.errors);
                return;
            }
            // Error general
            setError(
                err.response?.data?.error || 
                err.response?.data?.message || 
                'Error creando la empresa'
            );
        }
    }

    return {
        form,
        error,
        success,
        validationErrors,
        handleChange,
        submit,
        resetForm,
        clearError,
        clearSuccess,
        clearValidationErrors
    };
}